import { ExternalVideoModel } from "./model/external-video-data.model";

export class OpenDialog {
  static readonly type = '[External video] - Open dialog';

  constructor(public externalVideo: ExternalVideoModel) { }
}

export class CloseDialog {
  static readonly type = '[External video] - Close dialog';
}
